export default [
  {
    path: 'inst-sales-stats',
    redirect: { name: 'AgencyReportList' },
    children: [
      // 전체
      {
        path: 'list',
        name: 'AgencyReportList',
        meta: { menu: 'agency-report', keepAlive: true },
        component: () => import('@/pages/reportMng/instSalesStats/AgencyReportListView.vue')
      },
    ]
  }
]
